// Thema's (feat/themas, docs/ux/themas.md): "Voor wie is dit bord?" bij koppelen en bij Tablets,
// en de keuze van de pictogrammen in "Mijn thema" (alleen op dit apparaat).
export const appThemesNl = {
    audience: 'Thema van dit bord',
    audienceHint: 'Later te wijzigen bij Tablets, of op het bord zelf met Aanpassen (ook per scherm).',
    adult: 'Gezin en volwassenen',
    adultHint: 'Thema Volwassen: rustig en strak, neutrale kleuren en lijnpictogrammen.',
    kids: 'Kinderen',
    kidsHint: 'Thema Kinderen: kleurrijke pictogrammen, grotere knoppen en tekst. Staat het bord in de kamer van de kinderen, dan toont het alleen hun dingen.',
    pictos: 'Pictogrammen in de app',
    pictosHint: 'Geldt op dit apparaat.',
    pictosClean: 'Strak (rustige lijnen)',
    pictosColor: 'Speels (kleurrijk)',
};
//# sourceMappingURL=themesApp.nl.js.map